"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _ChevronButton = _interopRequireDefault(require("../button/ChevronButton"));

var _FormField = _interopRequireDefault(require("../FormField"));

var _StaggeredFadeIn = _interopRequireDefault(require("../effect/animation/StaggeredFadeIn"));

var _styling = require("../../toolkit/styling");

var _illustrations = require("../../toolkit/illustrations");

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/wish-express.svg' */

/* SVGs */
var wishExpressTruck = "data:image/svg+xml;base64,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";

/* babel-plugin-inline-import '../../img/dispute-in-progress.svg' */
var iconDisputeInProgress = "data:image/svg+xml;base64,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";

var CheckboxGroupField = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CheckboxGroupField, _Component);

  var _super = _createSuper(CheckboxGroupField);

  function CheckboxGroupField() {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxGroupField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "onChecked", _descriptor, (0, _assertThisInitialized2["default"])(_this));

    _this.renderBox = function (option) {
      var _this$props = _this.props,
          selected = _this$props.selected,
          checkSelected = _this$props.checkSelected;
      var isSelected = checkSelected ? checkSelected(option, selected) : selected.includes(option.value);

      var Icon = function Icon() {
        var icon = option.icon;

        if (!icon) {
          return null;
        }

        if (typeof icon == "function") {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon());
        }

        return /*#__PURE__*/_react["default"].createElement("img", {
          src: icon,
          alt: "wish express",
          className: (0, _styling.css)(_this.styles.icon)
        });
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: option.key || "checkbox_group_field_option_".concat(String(option.title)),
        className: (0, _styling.css)(_this.styles.option),
        onClick: function onClick() {
          return _this.onChecked(option);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        checked: isSelected,
        size: 12,
        className: (0, _styling.css)(_this.styles.checkbox)
      }), /*#__PURE__*/_react["default"].createElement(Icon, null), typeof option.title === "function" ? option.title() : /*#__PURE__*/_react["default"].createElement("label", {
        className: (0, _styling.css)(_this.styles.title)
      }, option.title));
    };

    _this.renderBoxes = function () {
      var _this$props2 = _this.props,
          collapsed = _this$props2.collapsed,
          collapsedAmount = _this$props2.collapsedAmount,
          options = _this$props2.options;
      var boxes = options.map(_this.renderBox);

      if (collapsedAmount != null) {
        if (collapsed) {
          return boxes.slice(0, collapsedAmount);
        }

        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, boxes.slice(0, collapsedAmount), /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
          animationDurationMs: 400
        }, boxes.slice(collapsedAmount)));
      }

      return boxes;
    };

    _this.renderShowButton = function () {
      var collapsed = _this.props.collapsed;

      var _LocalizationStore = new _localization.LocalizationStore(_this.context),
          i18n = _LocalizationStore.i18n;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.showButton),
        onClick: _this.props.onCollapseToggled
      }, /*#__PURE__*/_react["default"].createElement(_ChevronButton["default"], {
        direction: collapsed ? "down" : "up",
        onClick: function onClick() {},
        size: 10
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.showText)
      }, collapsed ? i18n("Show more") : i18n("Show less")));
    };

    return _this;
  }

  (0, _createClass2["default"])(CheckboxGroupField, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          title = _this$props3.title;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(className, style)
      }, /*#__PURE__*/_react["default"].createElement(_FormField["default"], {
        title: title
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root)
      }, this.renderBoxes())), this.canRenderShowButton && this.renderShowButton());
    }
  }, {
    key: "styles",
    get: function get() {
      var textBlack = this.context.theming.theme.textBlack;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          userSelect: "none"
        },
        option: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 17,
          ":last-child": {
            marginBottom: 0
          }
        },
        checkbox: {
          marginRight: 12
        },
        title: {
          fontSize: 14,
          color: textBlack,
          margin: 0
        },
        icon: {
          height: 19,
          marginRight: 6
        },
        showButton: {
          marginTop: 15,
          cursor: "pointer",
          display: "inline-flex",
          flexDirection: "row"
        },
        showText: {
          marginLeft: 10
        }
      });
    }
  }, {
    key: "canRenderShowButton",
    get: function get() {
      var _this$props4 = this.props,
          collapsedAmount = _this$props4.collapsedAmount,
          options = _this$props4.options;

      if (collapsedAmount == null) {
        return false;
      }

      return collapsedAmount < options.length;
    }
  }]);
  return CheckboxGroupField;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.demoProps = {
  options: [{
    title: "option a",
    value: "a",
    icon: _illustrations.lightBulb
  }, {
    title: "option b",
    value: "b",
    icon: wishExpressTruck
  }, {
    title: "option b",
    value: "c",
    icon: iconDisputeInProgress
  }],
  onChecked: function onChecked() {},
  selected: ["b"]
}, _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onChecked", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (option) {
      _this2.props.onChecked(option);
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "canRenderShowButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canRenderShowButton"), _class2.prototype)), _class2)) || _class;

var _default = CheckboxGroupField;
exports["default"] = _default;